import React from "react";

const ProfileSkeleton: React.FC = () => {
  return (
    <div className="space-y-6">
      {/* Parent Info Card Skeleton */}
      <div className="p-4 rounded-lg border border-indigo-200 bg-indigo-100 flex items-center gap-4 w-full">
        <div className="w-12 h-12 rounded-full bg-gray-200 animate-pulse" />
        <div className="flex-1 space-y-2">
          <div className="w-24 h-3 bg-gray-200 rounded animate-pulse" />
          <div className="w-40 h-4 bg-gray-200 rounded animate-pulse" />
          <div className="w-32 h-3 bg-gray-200 rounded animate-pulse" />
        </div>
      </div>

      {/* Profile Picture and Basic Info Skeleton */}
      <div className="flex flex-col sm:flex-row gap-4 ">
        <div className="flex justify-center sm:justify-start items-center">
          <div className="w-60 h-60 sm:min-h-[164px] sm:min-w-[164px] rounded-lg bg-gray-200 border-4 border-gray-300 animate-pulse" />
        </div>
        <div className="space-y-4 flex-1">
          {/* Name */}
          <div>
            <div className="mb-2 block">
              <div className="w-20 h-4 bg-gray-200 rounded animate-pulse" />
            </div>
            <div className="h-10 bg-gray-200 rounded animate-pulse" />
          </div>
          {/* Email */}
          <div>
            <div className="mb-2 block">
              <div className="w-20 h-4 bg-gray-200 rounded animate-pulse" />
            </div>
            <div className="h-10 bg-gray-200 rounded animate-pulse" />
          </div>
          {/* Company */}
          <div>
            <div className="mb-2 block">
              <div className="w-20 h-4 bg-gray-200 rounded animate-pulse" />
            </div>
            <div className="h-10 bg-gray-200 rounded animate-pulse" />
          </div>
        </div>
      </div>

      {/* Save Button Skeleton */}
      <div className="w-full h-10 bg-gray-200 rounded animate-pulse mt-4" />
    </div>
  );
};

export default ProfileSkeleton;
